app.directive('language', ["$translate", "$http", "$filter", function ($translate, $http, $filter) {
    return {
        restrict: 'E',
        replace: true,
        template: '<div class="lang-nav"><a class="current" data-lang="{{currentLang}}" ng-click="langon=!langon;">\
            			<i class="flag {{currentLang}}"></i>\
                        {{currentLang}}\
        			</a> \
                    <ul ng-show="langon">\
                    	<li ng-repeat="lang in languages track by $index" ng-hide="currentLang==lang">\
                    		<a ng-click="setLang(lang)" data-lang="{{lang}}">\
                    			<i class="flag {{lang}}"></i>\
                                {{lang}}\
                			</a>\
            			</li>\
                    </ul></div>',
        link: function ($scope, el, attrs) {

			var $translateThis = $filter('translate');

            function setCookie(key, value) {
                var expires = new Date();
                expires.setTime(expires.getTime() + (1 * 24 * 60 * 60 * 1000));
                document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
            }
        
            function getCookie(key) {
                var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
                return keyValue ? keyValue[2] : null;
            }

			getCultureLanguage();

			if (lang)
				$translate.use(lang);

            $scope.setLang = function (d) {
                $translate.use(d);
                setCookie('setLang', d);
                $scope.langon = false;
                $scope.currentLang = d;
				updateDatepickerRegion(d);
            }

            const lastLang = getCookie('setLang');
			$scope.currentLang = $translate.proposedLanguage() || $translate.use();

            if ( lastLang ) {
                $scope.currentLang = lastLang;
                $translate.use(lastLang)
            }else{
				$translate.use($scope.cultureLang);
				$scope.currentLang = $scope.cultureLang;	
            }

			if(gym[0].Languages != null){
				$scope.languages = gym[0].Languages.split(',');
				if( !$scope.languages.includes($scope.cultureLang)){
					$scope.languages.push($scope.cultureLang);
				}
			}else{
				$scope.languages = ['en', 'bg', 'es', 'esc', 'esm', 'pl', 'pt', 'it', 'ro'];
			}

			if ($scope.currentLang == 'bg') {
				$scope.AdditionInfo = $scope.gym[0].AdditionalInformation;
				$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['bg']);
			}else if($scope.currentLang == 'es' || $scope.currentLang == 'esc' || $scope.currentLang == 'esm'){
				$scope.AdditionInfo = $scope.gym[0].AddditionalInformationEN;
				$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['es']);
			}else if($scope.currentLang == 'pt'){
				$scope.AdditionInfo = $scope.gym[0].AddditionalInformationEN;
				$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['pt']);
			}else if($scope.currentLang == 'it'){
				$scope.AdditionInfo = $scope.gym[0].AddditionalInformationEN;
				$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['it']);
			}else if($scope.currentLang == 'ro'){
				$scope.AdditionInfo = $scope.gym[0].AddditionalInformationEN;
				$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['ro']);
			}else if(gym[0].Culture == 'en-GB'){
				$scope.AdditionInfo = $scope.gym[0].AddditionalInformationEN;
				$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['en-GB']);
			}else{
				$scope.AdditionInfo = $scope.gym[0].AddditionalInformationEN;
				$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['en']);
			}

			if ($scope.gym[0].Culture == 'en-US') {
				$('#from, #to, #schedule_to, #schedule_from').datepicker( "option", "dateFormat", "mm/dd/yy" );
			} else {
				$('#from, #to, #schedule_to, #schedule_from').datepicker( "option", "dateFormat", "dd/mm/yy" );
			}

			// Language Switch
			$scope.$on('$translateChangeSuccess', function (event, current, previous) {
				$scope.currentLang = $translate.proposedLanguage() || $translate.use();
			});

			let url = window.location.pathname;
			if (gymdivision && url.search('Schedulev2') >= 0) {
				$scope.currentLang = $translate.proposedLanguage() || $translate.use();
				var $translateThis = $filter('translate');
				var titleShedule = $translateThis('titleShedule');
				document.title = gymdivision + ' - ' + titleShedule;
			}
		

			function getCultureLanguage(){
				if (lang){
					$scope.cultureLang = lang;	
				}else if (gym[0].Culture.includes('-ES') ) {
					if (gym[0].Culture == 'ca-ES' || gym[0].Culture == 'ca-ES-valencia') {
						$scope.cultureLang = 'esc';	
					}else if(gym[0].Culture == 'es-MX'){
						$scope.cultureLang = 'esm';	
					}else{
						$scope.cultureLang = 'es';
					}
				}else if (gym[0].Culture == 'bg-BG'){
					$scope.cultureLang = 'bg';
				}else if (gym[0].Culture == 'pt-PT'){
					$scope.cultureLang = 'pt';
				}else if (gym[0].Culture == 'it-IT'){
					$scope.cultureLang = 'it';
				}else if (gym[0].Culture == 'ro-RO'){
					$scope.cultureLang = 'ro';
				}else{
					$scope.cultureLang = 'en';	
				}
			}

			function updateDatepickerRegion(e){
				var lang = e;

				if (lang == 'bg') {
					$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['bg']);
				}else if(lang == 'es' || lang == 'esc' || lang == 'esm'){
					$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['es']);
				}else if(lang == 'pt'){
					$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['pt']);
				}else if(lang == 'it'){
					$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['it']);
				}else if(lang == 'ro'){
					$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['ro']);
				}else if(gym[0].Culture == 'en-GB'){
					$scope.AdditionInfo = $scope.gym[0].AddditionalInformationEN;
					$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['en-GB']);
				}else{
					$('#from, #to, #schedule_to, #schedule_from').datepicker("option", $.datepicker.regional['en']);
				}

				if ($scope.gym[0].Culture == 'en-US') {
					$('#from, #to, #schedule_to, #schedule_from').datepicker( "option", "dateFormat", "mm/dd/yy" );
				} else {
					$('#from, #to, #schedule_to, #schedule_from').datepicker( "option", "dateFormat", "dd/mm/yy" );
				}

				if ($scope.AdditionInfo) {
					var prtext = $scope.AdditionInfo.replace(/\n/g, '<br />')
					$('.section-addtext').html(prtext);
				}
			}
        }
    };
}]);